import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon'
import { faCamera } from '@fortawesome/free-solid-svg-icons'

export const CameraIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faCamera} color={props.color} />
  )
}
